


export const siteConfig = {
  name: "OnePlace Deal",
  tagline: "Le bon professionnel, à portée de message",
  shortDescription:
    "OnePlace Deal met en relation des particuliers avec des professionnels de confiance  puis permet de contacter l’équipe OnePlaceDeal via WhatsApp ou Telegram.",
  longDescription:
    "OnePlace Deal présente des professionnels et des produits. Les demandes sont adressées à l’équipe OnePlaceDeal sur WhatsApp ou Telegram. Tout paiement doit être effectué uniquement auprès de ses agents officiels.",
  url: "https://OnePlacedeal.com",
  email: "oneplacedealadmin@gmail.com",
  supportPhone: "+31617362533",
  whatsappNumber: "+31 6 17362533",
  telegramHandle: "https://t.me/DealPlaceadmin",
  profileTelegramHandle: process.env.REACT_APP_PROFILE_TELEGRAM || "@admindeals03",
  address: "Belgique, Liège",
  legalEntity: "OnePlace Deal SARL",
  foundedYear: 2024,
  defaultCurrency: "USD" as const,
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=61594518279920",
    instagram: "https://www.instagram.com/oneplacedeal?stkn=MW9nbW5pdWs3dnozcw==",
    telegramLink: "https://t.me/@DealPlaceadmin",
   
  },
  stats: {
    professionals: 240,
    citiesCovered: 12,
    countriesCovered: 6,
    satisfactionRate: 97,
  },
};

export const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Profils", to: "/profils" },
  { label: "Produits", to: "/produits" },
  { label: "À propos", to: "/a-propos" },
];

export const footerLinks = {
  plateforme: [
    { label: "Accueil", to: "/" },
    { label: "Tous les profils", to: "/profils" },
    { label: "Tous les produits", to: "/produits" },
  ],
  entreprise: [
    { label: "À propos", to: "/a-propos" },
    { label: "Contact", to: "/contact" },
    { label: "Mes favoris", to: "/favoris" },
  ],
  legal: [
    { label: "Mentions légales", to: "/mentions-legales" },
    { label: "Politique de confidentialité", to: "/confidentialite" },
    { label: "Conditions d'utilisation", to: "/conditions-utilisation" },
  ],
};
